import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import HomePage from './home_page/HomePage';
import StatsPage from './stats_page/StatsPage';
import PersonalPage from './bot_manager_page/BotManagerPage';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/personal" element={<PersonalPage />} />
        </Routes>
      </Router>
    </Provider>
  </React.StrictMode>
);
